"use strict";

// Export the user's session ticket for authenticating with the backend.
let user = JSON.parse(localStorage.getItem("user"));
export const authHeader =
  user && user.SessionTicket ? { Authorization: user.SessionTicket } : {};
